module.exports = __webpack_public_path__ + "static/media/Vector (1).29f0344b.svg";